import { v4 as uuidv4 } from "uuid";

interface PSTNCallType {
  externalId?: string;
  numberCalled?: string;
  startedAt?: string;
  called: boolean;
  protocol?: string;
  requestedNumber?: string;
}

export default class PSTNCall {
  // Ids
  internalId: string;
  externalId?: string;
  requestedNumber?: string;

  // Numbers
  numberCalled?: string;
  protocol?: string;

  // Timestamps
  startedAt?: string;

  // Called
  called: boolean;
  active: boolean;

  constructor(options: PSTNCallType) {
    this.internalId = uuidv4();
    this.externalId = options.externalId;
    this.numberCalled = options.numberCalled;
    this.requestedNumber = options.requestedNumber;
    this.startedAt = options.startedAt;
    this.called = options.called;
    this.active = false;
  }
}

export class DialerPSTN {
  internalId: string;
  numberCalled: string;
  startedAt?: string;

  constructor(options: any) {
    this.internalId = uuidv4();
    this.numberCalled = options.numberCalled;
    this.startedAt = options.startedAt;
  }
}
